// client/src/helpers/planCCompletion.ts
//
// TRIL-116: Plan C completion-percentage helpers. Section 3 (verified
// credentials) is placeholder for TRIL-90/91 IDV — always false in v1.

import type { ProfessionalContext } from '../interfaces/user.interface';

export interface CompletionSnapshot {
  filled: number;
  total: 3;
  pct: number;
  sections: {
    required: boolean;
    optional: boolean;
    verified: boolean;
  };
}

export function hasRequiredSection(ctx: ProfessionalContext | null): boolean {
  if (!ctx) return false;
  return ctx.expertiseAreas.length >= 2 && Boolean(ctx.educationLevel);
}

export function hasOptionalDetails(ctx: ProfessionalContext | null): boolean {
  if (!ctx) return false;
  return (
    Boolean(ctx.jobTitle) ||
    Boolean(ctx.yearsExperience) ||
    (ctx.credentials?.length ?? 0) > 0
  );
}

export function computeCompletionPct(
  ctx: ProfessionalContext | null,
): CompletionSnapshot {
  const required = hasRequiredSection(ctx);
  const optional = hasOptionalDetails(ctx);
  const verified = false; // TRIL-90/91 IDV — locked in v1

  const filled = [required, optional, verified].filter(Boolean).length;
  return {
    filled,
    total: 3,
    pct: (filled / 3) * 100,
    sections: { required, optional, verified },
  };
}
